import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import './App.css';
import logo from '../images/logo.svg';
import { userIsLoggedIn } from '../auth';

import Main from './Main/Main';
import Login from './Login/Login';
import Auth from './Auth';

import UserList from '../components/User/UserList'

export default () => (
  <Auth>
    <div className="App">
      <Router>
        <Auth>
          <div className="App-header">
            <Link to={{ pathname: '/' }}>
              <img className="App-logo" src={logo} alt="Domality Logo" />
            </Link>
            
          </div>
          <Route
            render={({ location, ...rest }) => (
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  classNames="fade"
                  timeout={300}
                >
                  <Switch location={location}>
                    {/* App was turned into a SPA format, rendering anything but the auth route unecessary. they were kept for reference */}
                    <Route
                      path="/"
                      exact
                      {...rest}
                      location={location}
                      render={props =>
                        userIsLoggedIn() ? <Main /> : <Login />
                      }
                    />
                    {/* <Route
                      exact
                      path="/hardware/brand/:id"
                      component={props => (
                        <Brand brand={props.location.state} />
                      )}
                    /> */}
                    <Route
                      exact
                      path="/hardware/:id"
                      component={() => <div />}
                    />
                    <Route
                      exact
                      path="/products/:id"
                      component={() => <div />}
                    />
                    <Route
                      exact
                      path="/users"
                      component={props => <UserList />}
                    />
                    <Route render={() => <div>Not Found</div>} />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
        </Auth>
      </Router>
    </div>
  </Auth>
);



// WEBPACK FOOTER //
// ./src/components/App.js